// extracted by mini-css-extract-plugin
export default {"container":"GP-z","topReviewHeading":"HP-z","criticalReview":"IP-z","favorableReview":"JP-z","vsSeparator":"KP-z"};